<template>
	<button
		class="font-bold py-2 px-4 rounded focus:outline-none"
		:class="`bg-${color} hover:bg-${hoverColor} text-${typoColor} ${additionalClasses}`"
		@click="onClick($event)"
	>
		<slot></slot>
	</button>
</template>

<script>
export default {
	name: "RpButton",
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: "rypert-primary"
		},
		hoverColor: {
			type: String,
			default: "rypert-selected"
		},
		typoColor: {
			type: String,
			default: "white"
		}
	},
	computed: {
		additionalClasses() {
			return this.disabled
				? "opacity-50 cursor-not-allowed focus:outline-none"
				: "";
		}
	},
	methods: {
		onClick(e) {
			if (!this.disabled) {
				this.$emit("click", e);
			}
		}
	}
};
</script>

<style></style>
